(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/calculator-area-linear
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Calculates a linear measurement from area and unit width values.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("calculator-area-linear") === undefined) {
    class CalculatorAreaLinear extends HTMLElement {
        constructor(){
            super();
            this.inputArea = this.querySelector("[data-calculator-area-linear-area]");
            this.inputWidth = this.querySelector("[data-calculator-area-linear-width]");
            this.inputTotal = this.querySelector("[data-calculator-area-linear-total]");
            this.inputArea.addEventListener("input", this.updateArea.bind(this), false);
        }
        updateArea() {
            this.inputTotal.value = this.inputArea.valueAsNumber / this.inputWidth.valueAsNumber;
            this.inputTotal.dispatchEvent(new Event("input"));
        }
    }
    customElements.define("calculator-area-linear", CalculatorAreaLinear);
}



})();
